import React from 'react'
import ResetPin from '../Components/Vault/Pin/ResetPin'

const resetPin = () => {
  return (
    <div><ResetPin/></div>
  )
}

export default resetPin